import { Dropzone as MantineDropzone, DropzoneProps } from '@mantine/dropzone';

export type IDropzoneProps = DropzoneProps;

/** @registry Design-layer pass-through over Mantine Dropzone; prefer src/design/organisms/FileDrop for the standard file-drop experience. Extend here when Dropzone needs house behavior. Compound statics (Dropzone.Accept, Dropzone.Idle, Dropzone.Reject, Dropzone.FullScreen) are preserved. */
export const Dropzone = MantineDropzone;
